module.exports = __webpack_public_path__ + "static/media/2.087b93a1.jpg";